import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowLeftShort = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8 13",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		transform: "rotate(-180 3.9630513191223145,6.5840253829956055)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "nonzero",
			d: "M.59 11.34l4.58-4.59L.59 2.16 2 .75l6 6-6 6z"
		})
	})
});
export default SvgArrowLeftShort;
